import { default as useAsync } from './useAsync';
import { default as useBeforeUnload } from './useBeforeUnload';
import { default as useHash } from './useHash';
import type { Callback as HashCallback } from './useHash';
import { default as useKeyboardEnter } from './useKeyboardEnter';
import { default as useKeyboardTab } from './useKeyboardTab';
import { default as useMouseLeftClick } from './useMouseLeftClick';
import { default as usePaypal } from './usePaypal';
import type { Props as PaypalProps } from './usePaypal';
import { default as useSubscription, SourceInput } from './useSubscription';

// named export custom hooks that are required only within the component-library project
export type { HashCallback, SourceInput, PaypalProps };

// export custom hooks that can be consumed both in the library and related transactions
export default {
  usePaypal,
  useSubscription,
  useHash,
  useAsync,
  useBeforeUnload,
  useKeyboardTab,
  useMouseLeftClick,
  useKeyboardEnter
};
